/** The attribute a check's row carries in its category tab, so a link can land on it. */
export const CHECK_ANCHOR = 'data-isfr-check';

/** The attribute a flag's entry carries on the Approval Summary, for the summary's own links. */
export const WORTH_ANCHOR = 'data-isfr-worth';

// The check a link is opening its tab to. A folded group that holds it opens as
// the tab renders, so the row is there to scroll to.
let linkTarget = null;
export const isLinkTarget = (checkId) => linkTarget !== null && linkTarget === checkId;

/** Scrolls to an entry on the page the link is on. */
export const scrollToEntry = (attribute, value) => {
  const target = document.querySelector(`[${attribute}="${value}"]`);
  if (target && typeof target.scrollIntoView === 'function') target.scrollIntoView({ block: 'start' });
};

/**
 * Opens a detail-page tab from an in-page link and scrolls to where the link
 * points: one check's row when a check id is given, else the top of the tab, so
 * the reviewer never lands at the scroll position of the link they followed.
 * Cloudscape puts each tab's id on its tab button as data-testid, the one handle
 * the page gives on it. The scroll waits a frame for the new tab to render, and
 * a check not found lands at the top of its tab.
 */
export const openTabAtTop = (onOpenTab) => (tabId, checkId) => {
  linkTarget = checkId || null;
  onOpenTab(tabId);
  const scroll = () => {
    linkTarget = null;
    const target = (checkId && document.querySelector(`[${CHECK_ANCHOR}="${checkId}"]`))
      || document.querySelector(`[data-testid="${tabId}"]`);
    if (target && typeof target.scrollIntoView === 'function') target.scrollIntoView({ block: 'start' });
  };
  if (typeof window.requestAnimationFrame === 'function') window.requestAnimationFrame(scroll);
  else scroll();
};
